import {
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState,useEffect } from "react";
import Heading from "../../../../../components/common/heading";

const { useToken } = theme;

const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

// const Behavior = (
  
//   props) => {
//   const { token } = useToken();
//   const [form] = Form.useForm();
//   const [checkOther, setCheckOther] = useState(false);
//   const { dropDownKnowChannel, handleOnChangeVOC ,actionType, channel, } = props;

//   const onChange = (value) => {
//     if (value === "other") {
//       setCheckOther(true);
//     } else {
//       setCheckOther(false);
//     }
//   };
//   useEffect(() => {
//   if (actionType === "CREATE" && channel) {
//     form.setFieldsValue({
//       dropDownKnowChannel: [channel], // ⬅ multiple ต้องเป็น array
//     });
//   }
// }, [actionType, channel, form]);
//   return (
//     <Content style={{ paddingTop: 15 }}>
//       <Row gutter={[8, 16]} className="card">
//         <Col span={24}>
//           <Heading
//             text={"บันทึกพฤติกรรมลูกค้า"}
//             size={4}
//             style={{ margin: 0, color: token.thPrimary }}
//           />
//           <Divider />
//         </Col>

//         <Col span={16}>
//           <Form.Item label="บันทึกพฤติกรรมลูกค้า " name={"customer_behavior"}>
//             <TextArea rows={4} placeholder="รายละเอียด" />
//           </Form.Item>
//         </Col>
//         {/* <Col span={16}>
//           <Form.Item
//             label="ช่องทางรู้จักกับทาง กนอ. (ตอบได้มากกว่า 1 ข้อ)"
//             name={"dropDownKnowChannel"}
//           >
//             <Select
//               mode={"multiple"}
//               allowClear
//               disabled = {true}
//               showSearch={false}
//               className="w-full"
//               placeholder="กรุณาเลือก"
//               optionFilterProp="children"
//               onChange={(value, type) =>
//                 handleOnChangeVOC(value, "dropDownKnowChannel")
//               }
//               hasfeedback="true"
//             >
//               {dropDownKnowChannel.map((option, i) => {
//                 return (
//                   <Option key={i} value={option.dataId}>
//                     {option.dataDetailTh}
//                   </Option>
//                 );
//               })}
//             </Select>
//           </Form.Item>
//         </Col> */}
//         <Col span={16}>
//           <Form.Item
//             label="ช่องทางรู้จักกับทาง กนอ. (ตอบได้มากกว่า 1 ข้อ)"
//             name="dropDownKnowChannel"
//           >
//             <Select
//               mode="multiple"
//               allowClear
//               disabled={actionType === "CREATE"}
//               showSearch={false}
//               className="w-full"
//               placeholder="กรุณาเลือก"
//               optionFilterProp="children"
//               onChange={(value) =>
//                 handleOnChangeVOC(value, "dropDownKnowChannel")
//               }
//             >
//               {dropDownKnowChannel.map((option) => (
//                 <Select.Option key={option.dataId} value={option.dataId}>
//                   {option.dataDetailTh}
//                 </Select.Option>
//               ))}
//             </Select>
//           </Form.Item>
//         </Col>

//         {checkOther && (
//           <>
//             <Col span={16} style={{ paddingTop: 0 }}>
//               <Form.Item name={"other_detail"}>
//                 <TextArea rows={4} placeholder="รายละเอียด" />
//               </Form.Item>
//             </Col>
//           </>
//         )}

//         <Col span={16}>
//           <Form.Item
//             label="ข้อเสนอแนะช่องทางการสื่อสารและ การให้บริการที่ลูกค้าใช้ในการติดต่อ (ถ้ามี) "
//             name={"suggestion"}
//           >
//             <TextArea rows={4} placeholder="รายละเอียด" />
//           </Form.Item>
//         </Col>
//       </Row>
//     </Content>
//   );
// };

// export default Behavior;
const Behavior = (props) => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const [checkOther, setCheckOther] = useState(false);

  const {
    dropDownKnowChannel,
    handleOnChangeVOC,
    actionType,
    channel,
    setBehaviorChannel
  } = props;

  if(actionType === "CREATE" && channel){
    setBehaviorChannel(channel)
    form.setFieldsValue({dropDownKnowChannel:channel})
  }
  // useEffect(() => {
  //   if (actionType === "CREATE" && channel) {
  //     form.setFieldsValue({
  //       dropDownKnowChannel: [channel],
  //     });
  //   }
  // }, [actionType, channel]);

  const onChannelChange = (values) => {
    handleOnChangeVOC(values, "dropDownKnowChannel");

    if (Array.isArray(values) && values.includes("other")) {
      setCheckOther(true);
    } else {
      setCheckOther(false);
    }
  };

  return (
      <Content style={{ paddingTop: 15 }}>
        <Row gutter={[8, 16]} className="card">
          <Col span={24}>
            <Heading
              text="บันทึกพฤติกรรมลูกค้า"
              size={4}
              style={{ margin: 0, color: token.thPrimary }}
            />
            <Divider />
          </Col>

          <Col span={16}>
            <Form.Item
              label="ช่องทางรู้จักกับทาง กนอ."
              name="dropDownKnowChannel"
            >
              <Select
                mode="multiple"
                allowClear
                disabled={actionType === "CREATE"}
                placeholder="กรุณาเลือก"
                onChange={onChannelChange}
              >
                {dropDownKnowChannel.map((option) => (
                  <Select.Option
                    key={option.dataId}
                    value={option.dataId}
                  >
                    {option.dataDetailTh}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {checkOther && (
            <>
              <Col span={16} style={{ paddingTop: 0 }}>
                <Form.Item name={"other_detail"}>
                  <TextArea rows={4} placeholder="รายละเอียด" />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={16}>
            <Form.Item
              label="ข้อเสนอแนะช่องทางการสื่อสารและ การให้บริการที่ลูกค้าใช้ในการติดต่อ (ถ้ามี) "
              name={"suggestion"}
            >
              <TextArea rows={4} placeholder="รายละเอียด" />
            </Form.Item>
          </Col>
        </Row>
      </Content>
  );
};
export default Behavior;
